(function () {
  var root = document.querySelector('[data-wbv4-root]');
  if (!root) return;

  var chips = root.querySelectorAll('[data-wbv4-variant]');
  var price = root.querySelector('[data-wbv4-price]');
  var availability = root.querySelector('[data-wbv4-availability]');
  var add = root.querySelector('[data-wbv4-add]');
  var mainImage = root.querySelector('[data-wbv4-main-image]');
  var shipLine = root.querySelector('[data-wbv4-ship-line]');
  var shipBlock = root.querySelector('[data-wbv4-ship]');
  var shipMeter = root.querySelector('[data-wbv4-ship-meter]');
  var shipFill = root.querySelector('[data-wbv4-ship-fill]');
  var quantityInput = root.querySelector('[data-wbv4-quantity-input]');
  var FREE_SHIPPING_THRESHOLD = 15000;

  // V4 has no variant resolution to do. The checked radio IS the variant field
  // Shopify submits, so this file only reflects the choice — it can never
  // disagree with it. Deleted from V3 along the way: findVariant,
  // nearestVariant, syncAvailability, syncFinishCards, syncSizeCards,
  // syncGuideCards, announce + the undo handler, and the substitution live
  // region. None of them have anything left to coordinate.

  function money(cents) {
    var hasCents = cents % 100 !== 0;
    return new Intl.NumberFormat(undefined, {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: hasCents ? 2 : 0,
      maximumFractionDigits: hasCents ? 2 : 0
    }).format(cents / 100);
  }

  function setImage(src) {
    if (!mainImage || !src || mainImage.getAttribute('src') === src) return;
    mainImage.style.opacity = '0.3';
    mainImage.src = src;
    mainImage.onload = function () { mainImage.style.opacity = '1'; };
  }

  function selected() {
    return Array.prototype.filter.call(chips, function (chip) { return chip.checked; })[0];
  }

  function currentQty() {
    var n = quantityInput ? Number(quantityInput.value) : 1;
    return isFinite(n) && n > 0 ? Math.floor(n) : 1;
  }

  // Line total, not the bare chip price — see the V3 note. Cart contents added
  // from other pages are still not visible here.
  function syncShipping() {
    var chip = selected();
    if (!shipLine || !chip) return;
    var total = Number(chip.getAttribute('data-price')) * currentQty();
    var qualified = total >= FREE_SHIPPING_THRESHOLD;

    shipLine.textContent = qualified
      ? 'Free US shipping unlocked'
      : 'Add ' + money(FREE_SHIPPING_THRESHOLD - total) + ' for free US shipping';
    if (shipBlock) shipBlock.classList.toggle('is-qualified', qualified);
    if (shipMeter) shipMeter.textContent = money(total) + ' of ' + money(FREE_SHIPPING_THRESHOLD);
    if (shipFill) {
      shipFill.style.width = Math.min(100, Math.round(total / FREE_SHIPPING_THRESHOLD * 100)) + '%';
    }
  }

  function update() {
    var chip = selected();
    if (!chip) return;
    var cents = Number(chip.getAttribute('data-price'));
    var available = chip.getAttribute('data-available') !== 'false';

    if (price) price.textContent = money(cents);
    if (availability) availability.textContent = available ? '' : 'Currently unavailable';
    if (add) add.disabled = !available;
    setImage(chip.getAttribute('data-image'));

    syncShipping();
  }

  Array.prototype.forEach.call(chips, function (chip) {
    chip.addEventListener('change', update);
  });

  Array.prototype.forEach.call(root.querySelectorAll('[data-wbv4-quantity]'), function (button) {
    button.addEventListener('click', function () {
      quantityInput.value = Math.max(1, Number(quantityInput.value || 1) + Number(button.getAttribute('data-wbv4-quantity')));
      syncShipping();
    });
  });
  if (quantityInput) {
    quantityInput.addEventListener('input', syncShipping);
  }

  // Size guide is reference material in V4 — it explains scale, it does not
  // select. Native <dialog> supplies Esc, focus trap, backdrop and focus return.
  var guide = root.querySelector('[data-wbv4-size-guide]');
  if (guide) {
    if (guide.parentElement !== document.body) document.body.appendChild(guide);
    if (guide.open) guide.close();

    function openGuide() {
      if (guide.open) guide.close();
      try { guide.showModal(); } catch (error) { guide.setAttribute('open', ''); }
    }

    Array.prototype.forEach.call(root.querySelectorAll('[data-wbv4-size-guide-open]'), function (trigger) {
      trigger.addEventListener('click', openGuide);
    });
    Array.prototype.forEach.call(guide.querySelectorAll('[data-wbv4-size-guide-close]'), function (button) {
      button.addEventListener('click', function () { guide.close(); });
    });
    guide.addEventListener('click', function (event) {
      if (event.target === guide) guide.close();
    });
  }

  Array.prototype.forEach.call(root.querySelectorAll('[data-wbv4-shop]'), function (button) {
    button.addEventListener('click', function () {
      var controls = root.querySelector('#wbv4-purchase-controls');
      if (!controls) return;
      controls.scrollIntoView({behavior: 'smooth', block: 'center'});
      var firstChip = controls.querySelector('[data-wbv4-variant]:checked') || controls.querySelector('[data-wbv4-variant]');
      if (firstChip) window.setTimeout(function () { firstChip.focus({preventScroll: true}); }, 500);
    });
  });

  update();
}());
